/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Error_LargeInputs */

const en_story_error_large = /** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File too large. Maximum is 50MB.`)
};

const es_story_error_large = /** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo demasiado grande. El máximo es 50MB.`)
};

const fr_story_error_large = /** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier trop volumineux. Le maximum est de 50 Mo.`)
};

const de_story_error_large = /** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei zu groß. Das Maximum ist 50MB.`)
};

const id_story_error_large = /** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File terlalu besar. Maksimum adalah 50MB.`)
};

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const ja_story_error_large = en_story_error_large;

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const zh_story_error_large = en_story_error_large;

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const ar_story_error_large = en_story_error_large;

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const it_story_error_large = en_story_error_large;

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const ru_story_error_large = en_story_error_large;

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const pt_story_error_large = en_story_error_large;

/** @type {(inputs: Story_Error_LargeInputs) => LocalizedString} */
const ko_story_error_large = en_story_error_large;

/**
* | output |
* | --- |
* | "File too large. Maximum is 50MB." |
*
* @param {Story_Error_LargeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_error_large = /** @type {((inputs?: Story_Error_LargeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Error_LargeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_error_large(inputs)
	if (locale === "es") return es_story_error_large(inputs)
	if (locale === "fr") return fr_story_error_large(inputs)
	if (locale === "de") return de_story_error_large(inputs)
	if (locale === "ja") return ja_story_error_large(inputs)
	if (locale === "zh") return zh_story_error_large(inputs)
	if (locale === "ar") return ar_story_error_large(inputs)
	if (locale === "id") return id_story_error_large(inputs)
	if (locale === "it") return it_story_error_large(inputs)
	if (locale === "ru") return ru_story_error_large(inputs)
	if (locale === "pt") return pt_story_error_large(inputs)
	return ko_story_error_large(inputs)
});